import React from 'react'

const Report = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<path d="M14.7647 5.35294L13.5882 3H4.17645V23H6.52939V14.7647H12.4117L13.5882 17.1176H21.8235V5.35294H14.7647ZM19.4706 14.7647H14.7647L13.5882 12.4118H6.52939V5.35294H12.4117L13.5882 7.70588H19.4706V14.7647Z" fill="currentColor"></path>
</svg>
    )
}

export default Report
